// Importing 3rd party dependencies
import { useMemo, useSyncExternalStore } from 'react';
// ----------------------------------------------------------------------
export const useSliderPosition = () => {
    // Helper function to subscribe to resize events
    const subscribe = (callback) => {
        window.addEventListener('resize', callback);
        return () => {
            window.removeEventListener('resize', callback);
        };
    };
    // Hook to get dimensions of element
    // See: https://stackoverflow.com/a/75101934
    const useDimensions = (ref) => {
        const dimensions = useSyncExternalStore(subscribe, () => {
            var _a, _b, _c, _d;
            return JSON.stringify({
                width: (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0,
                height: (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0,
            });
        });
        return useMemo(() => JSON.parse(dimensions), [dimensions]);
    };
    // Returning all hook options
    return { useDimensions };
};
